import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export const modalStyles = () =>
  createStyles({
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 10,
      fontSize: '14px !important',
      minWidth: 400,
      backgroundColor: palette.deepBlue,
    },
    titleText: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      fontSize: '14px !important',
      fontWeight: 500,
      color: palette.lightNavSuperAdminActions,
    },
    content: {
      padding: 12,
      maxHeight: 470,
      overflowX: 'auto',
      fontSize: '12px !important',
    },
    contentText: { fontSize: '12px !important' },

    buttonsContainer: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      borderTop: `1px solid ${palette.borderGray}`,
    },
  });
export default () =>
  createStyles({
    deviceIconCell: {
      width: 20,
      padding: 0,
      textAlign: 'center',

      '& svg': {
        fontSize: 16,
        fill: palette.gray,
      },
    },
    currentDeviceRow: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        color: palette.primary.main,
      },
    },
    tableRow: {
      height: 20,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '& .MuiTableCell-root': {
        padding: '0 0 0 16px',
        color: palette.gray,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    deleteButton: {
      color: palette.red,
      '&:hover': {
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
      },
    },

    osIcon: {
      display: 'flex',
    },
    osIconImage: {
      width: 16,
      height: 16,
      marginLeft: 8,
    },
    centerSmallFields: {
      padding: '0px !important',
    },
  });
